import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const ResetPasswordSuccess = ({ strings }) => (
  <>
    <div className="icon-heading">
      <IconSvg type="checkmark" className="icon--success" />
    </div>
    <h1 className="page-heading">{strings.passwordUpdated}</h1>
  </>
);

ResetPasswordSuccess.propTypes = {
  strings: PropTypes.object.isRequired,
};

export default ResetPasswordSuccess;
